export const careersEndpoints = {
  careersPage: '/public/careers/{slug}',
  applications: '/public/careers/jobs/{jobId}/applications',
} as const;
